// extracted by mini-css-extract-plugin
export default {"content":"swishModal_content__NpGgt","title":"swishModal_title__nVbdZ","buttons":"swishModal_buttons__HwQCe","button":"swishModal_button__hqJAV"};